import React from "react";

export default function SectionCard({ title, subtitle, rightSlot, children, darkMode = false }) {
  return (
    <section className={`
      rounded-xl border p-6
      transition-all duration-200
      ${darkMode
        ? 'bg-neutral-900 border-neutral-800 shadow-md hover:shadow-lg'
        : 'bg-white border-neutral-200 shadow-sm hover:shadow-md'
      }
    `}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className={`text-sm font-medium ${darkMode ? 'text-neutral-500' : 'text-neutral-600'}`}>
            {title}
          </h2>
          {subtitle && (
            <p className={`text-xs mt-1 ${darkMode ? 'text-neutral-600' : 'text-neutral-500'}`}>
              {subtitle}
            </p>
          )}
        </div>
        {rightSlot && <div className="shrink-0">{rightSlot}</div>}
      </div>

      <div className="mt-4">{children}</div>
    </section>
  );
}
